import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {Button, Dropdown, DropdownMenu, Form, Icon, Input} from "semantic-ui-react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as searchActions from "../../../../store/actions/search.actions";
import { SearchActions } from "../../../../store/actions/search.actions";
import {
    useIncludeMilestonesSelector,
    useSearchLoadingSelector,
    useSearchParamatersSelector,
} from "../../../../store/selectors/search.selectors";
import { ChipsList } from "./components/ChipsList";
import styles from "./SearchBar.module.scss";
import classNames from "classnames";
import { ReportDropdown } from "./components/ReportsDropdown";
import { useUserGradeSelector, useUserSelector } from "../../../../store/selectors/authorization.selectors";
import { debounce } from "../../../../utils/debounce";
import { SearchThunk } from "../../../../store/thunk/search.thunk";
import { useTypedSelector } from "../../../../store/selectors/selectors.utils";
import * as taskActions from "../../../../store/actions/task.actions";
import * as projectActions from "../../../../store/actions/project.actions";
import * as workPackageActions from "../../../../store/actions/work-package.actions";
import {
    useAllTaskListSelector, useFilteredTaskListSelector,
    usePredeccessorsViewSelector,
    useSuccessorsViewSelector,
} from "../../../../store/selectors/task/task.selectors";
import {
    useActiveProjectSelector, useCpmMapSelector, useDagOpenSelector, useFrozenWarningSelector,
    useOpenTaskDetailsSelector, useProjectRiskSelector,
    useProjectViewSelector, useRiskMappingSelector
} from "../../../../store/selectors/project.selectors";
import { useActiveTaskSelector } from "../../../../store/selectors/task/task.selectors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faCommentsAlt,
  faUsers,
  faTimes,
  faExclamation,
  faHandshakeAlt,
  faSearch, faPlus, faChartPie, faMapLocationDot, faChartGantt, faPrint, faDiamond, faUsersSlash,
  faPersonRunningFast, faMemoCircleInfo, faCrown, faDiagramProject, faCheck, faXmark, faChartCandlestick, faSnowflake,
  faFire, faLocationCrosshairs, faReflectHorizontal, faBoxOpenFull
} from "@fortawesome/pro-light-svg-icons";
import {faTimes as faTimesSolid} from "@fortawesome/pro-solid-svg-icons";
import NewTaskModal from "../../pages/FlowPage/components/NewTaskModal";
import { MemberOrganizationEnum } from "../../../../models/member-organization.enum";
import {userHasSeen} from "../../../../utils/taskforce.utils";
import DatePicker from "react-datepicker";
import OnlineUsers from "./components/OnlineUsers";
import FirebaseUsage from "../../../../firebase/firebase.usage";
import moment from "moment";
import FirebaseProjectFunctions from "../../../../firebase/firebase-functions/project-service";
import {
    useActiveWorkPackageSelector,
    useProjectHasWorkPackagesSelector,
    useWorkPackagesSelector
} from "../../../../store/selectors/work-packages.selectors";
import {RiskModel} from "../../../../models/responses/risk.model";
import TaskModel from "../../../../models/responses/task.model";
import {COLLECTIONS} from "../../../../firebase/constants";
import batchUpdate from "../../../../utils/firestoreBatch.utils";

interface InjectedProps {
  disabled: boolean;
  openSpecificAdditional: (
    type: "ledger" | "member" | "profile" | "calendar", open: boolean
  ) => void;
  isOpenedLedger: boolean;
  isOpenedMember: boolean;
  isOpenedProfile: boolean;
  isOpenedCalendar: boolean;
  isLarge: boolean;
  setLargeMode: Dispatch<SetStateAction<boolean>>;
}

export const SearchBar: React.FC<InjectedProps> = (props) => {
  const location = useLocation();
  const userGrade = useUserGradeSelector();
  const activeProject = useActiveProjectSelector();
  const activeTask = useActiveTaskSelector();
  const activeWorkPackage = useActiveWorkPackageSelector();
  const lightSelectedTask = useTypedSelector(
    (state) => state.task.lightSelectedTask
  );
  const selectedTask = useMemo(
    () => lightSelectedTask || activeTask,
    [lightSelectedTask, activeTask]
  );

  const searchBarLoading = useSearchLoadingSelector();
  const dispatch = useDispatch();
  const hasProjectBeenSelected = useTypedSelector((state) =>
    Boolean(state.project.activeProject)
  );
  const searchInputRef = useRef<any>(null);
  const searchParameters = useSearchParamatersSelector();
  const user = useUserSelector();
  const [expandedSearchBar, setExpandedSearchBar] = useState(false);
  const [newTaskModalOpen, setNewTaskModalOpen] = useState(false);
  const predecessorsView = usePredeccessorsViewSelector();
  const successorsView = useSuccessorsViewSelector();
  const showMilestones = useIncludeMilestonesSelector();
  const projectView = useProjectViewSelector();
  const [checklists, setChecklists] = useState(false);
  const [map, setMap] = useState(false);;
  const [hoverButton, setHoverButton] = useState<any>(null);
  const [dateFilterOpen, setDateFilterOpen] = useState(false);
  const [showFreezer, setShowFreezer] = useState(false);
  const [freezerDate, setFreezerDate] = useState<Date | null>(null);
  const isDagOpen = useDagOpenSelector();
  const showTaskDetails = useOpenTaskDetailsSelector();
  const showFrozenWarning = useFrozenWarningSelector();
  const view = useMemo(() => {
    if (predecessorsView) {
      return "predecessors";
    } else {
      return "successors";
    }
  }, [predecessorsView]);
  const projectHasWorkPackages = useProjectHasWorkPackagesSelector();
  const riskMapping = useRiskMappingSelector();
  const risks = useProjectRiskSelector();
  const filteredTaskList = useFilteredTaskListSelector();
  const workPackages = useWorkPackagesSelector();

  const handleChangeSearchValue = useCallback(
    debounce((value) => {
      if (value.length >= 3) {
        // @ts-ignore
        dispatch(SearchThunk.setSearchValue(value));
        dispatch(SearchActions.setIncludeMilestones(true));
      } else {
        // @ts-ignore
        dispatch(SearchThunk.setSearchValue(""));
      }
    }, 500),
    [dispatch]
  );

    useEffect(() => {
        if (activeProject && activeProject.frozenDate && !freezerDate) {
            setFreezerDate(activeProject.frozenDate.toDate());
        } else if (!freezerDate && activeProject) {
            setFreezerDate(new Date());
        }
    }, [activeProject]);

  const closeView = useCallback(
    (view: "successors" | "predecessors") => {
      // props.setIsSearchBarDisabled(false);
      dispatch(taskActions.Actions.closeRelatedTaskList(view));
    },
    [dispatch]
  );

  const addChip = useCallback(async () => {
    if (searchInputRef && searchInputRef.current) {
      const value = searchInputRef.current.inputRef.current.value;
      if (value.length >= 3) {
        setExpandedSearchBar(true);
        dispatch(SearchActions.addChip([{ type: "filter", text: value }]));
        await handleChangeSearchValue("");
        searchInputRef.current.inputRef.current.value = "";
        setExpandedSearchBar(false);
        searchInputRef.current.inputRef.current.blur();
      } else if (value.length === 0) {
        setExpandedSearchBar(!expandedSearchBar);
        await handleChangeSearchValue("");
        searchInputRef.current.inputRef.current.value = "";
      }
    }
  }, [handleChangeSearchValue, dispatch, expandedSearchBar, searchInputRef]);

  const toggleOnlyMyTasks = useCallback(() => {
    setHoverButton(null)
    if (!user) {
      return;
    }
    if (searchParameters.taskForces.some(taskForce => taskForce && taskForce[0] === user.userId)) {
      dispatch(
        searchActions.SearchActions.removeIdFromTaskforecFilter([user.userId])
      );
    } else {
        dispatch(searchActions.SearchActions.setTaskforceFilter([[user!.userId!, user.userEmail]]));
    }
  }, [searchParameters, user, dispatch]);

 // useEffect(() => {
 //   if (!hasToggled && activeProject && user) {
 //     const filteredTaskList = allTasks.filter((task) => {
 //       return task.taskForce.includes(user.userId);
 //     });
 //     if (
 //       myTasksParam ||
 //       (!userGrade[MemberOrganizationEnum.SUPER_ACTOR] &&
 //         filteredTaskList.length > 0)
 //     ) {
 //       toggleOnlyMyTasks();
 //       setHasToggled(true);
 //     }
 //   }
 // }, [activeProject, user, myTasksParam, userGrade, hasToggled, setHasToggled]);

  const updateUserTaskSeenHandler = useCallback(() => {
    if (user && activeTask && activeTask!.taskForce.includes(user.userId)) {
        userHasSeen(user!.userId!, activeTask).catch((e) => console.error(e));
    }
  }, [activeTask, dispatch, user]);

  const taskId = useMemo(() => activeTask?.task_id, [activeTask]);

  useEffect(() => {
    if (props.isOpenedLedger && taskId && user && activeTask && activeTask!.taskForce.includes(user.userId)) {
        userHasSeen(user!.userId!, activeTask!).catch((e) => console.error(e));
    }
  }, [dispatch, taskId, props.isOpenedLedger, user]);

  const wbsAdressNames = useMemo(() => {
    const wbsAddress = selectedTask ? selectedTask.wbsPath !== '' ? selectedTask.wbsPath : selectedTask.wbs : "WBS Path:";
    return wbsAddress;
  }, [selectedTask]);

  const newWbsAddress: string = useMemo(() => {
    return wbsAdressNames
  }, [wbsAdressNames, activeProject]);

  if (!user) {
    return null;
  }

    function handleHoverButton(text: string) {
      const getParams = (id: string) => {
          return document.getElementById(id)?.getBoundingClientRect();
      }

      const setParams = (text: string, params: any) => {
          const width = text.length * 6.8;
          const screen = window.innerWidth;
          let x = params.x - (width / 2) + (params.width / 2);
            if (x < 0) {
                x = 0;
            } else if (x + width > screen) {
                x = screen - width;
            }
          setHoverButton({
                x: x,
                y: params.y + 38,
                text: text
          })
      }

      let params: any
      switch (text) {
          case "Tasks with alerts":
            params = getParams("alert");
            setParams("Tasks with alerts", params);
            break;
          case "My tasks":
            params = getParams("myTasks");
            setParams("My tasks", params);
            break;
          case "Tasks with no task force":
            params = getParams("noTaskForce");
            setParams("Tasks with no owner", params);
            break;
          case "Add new task":
            params = getParams("addTask");
            setParams("Add new task", params);
            break;
          case "Show milestones":
            params = getParams("milestones");
            setParams("Show milestones", params);
            break;
          case "Search tasks":
            params = getParams("search");
            setParams("Search tasks", params);
            break;
          case "Apply time filter":
            params = getParams("timeFilter");
            setParams("Apply time filter", params);
            break;
          case "Print Gantt chart":
            params = getParams("printGantt");
            setParams("Print Gantt chart", params);
            break;
          case "Gantt view":
            params = getParams("gantt");
            setParams("Gantt view", params);
            break;
          case "Open map":
            params = getParams("map-button");
            setParams("Open map", params);
            break;
          case "Quality view":
            params = getParams("quality");
            setParams("Quality view", params);
            break;
          case "Task calendar":
            params = getParams("calendar");
            setParams("Task calendar", params);
            break;
          case "Task ledger":
            params = getParams("ledger");
            setParams("Task ledger", params);
            break;
          case "Project team":
            params = getParams("member");
            setParams("Project team", params);
            break;
          case "Sprint view":
            params = getParams("sprint");
            setParams("Sprint view", params);
            break;
          case "Change log":
            params = getParams("change");
            setParams("Change log", params);
            break;
        case "Show task details":
            params = getParams("taskDetails");
            setParams("Show task details", params);
            break;
        case "Dashboard view":
            params = getParams("dashboard");
            setParams("Dashboard view", params);
            break;
        case "My owned tasks":
            params = getParams("owner");
            setParams("My owned tasks", params);
            break;
        case "Checklists":
            params = getParams("checklists");
            setParams("Checklists", params);
            break;
        case "Show network":
            params = getParams("Show network diagram");
            setParams("Activity network", params);
            break;
        case "Risk view":
            params = getParams("risks");
            setParams("Risk view", params);
            break;
        case "Freeze flow":
            params = getParams("freezeFlow");
            setParams(activeProject && activeProject.frozen ? "Unfreeze flow" : "Freeze flow", params);
            break;
        case "Focus on task":
            params = getParams("focusOnTask");
            setParams("Focus on selected task", params);
            break;
        case "Work packages":
            params = getParams("workpacks");
            setParams("Work packages", params);
            break;
        case "Work package filter":
            params = getParams("workPackages");
            setParams("Work package filter", params);
            break;
      }
  }

  const commitFreezerDate = useCallback(() => {
    if (activeProject && activeProject.projectId && freezerDate) {
        FirebaseUsage.updateDoc("projects", activeProject.projectId, {
            frozen: true,
            frozenDate: FirebaseUsage.timestamp(new Date(freezerDate.setHours(0,0, 0)))
        })
            .then(() => {
                dispatch(projectActions.Actions.setActiveProject({...activeProject,
                    frozen: true,
                    frozenDate: FirebaseUsage.timestamp(new Date(freezerDate.setHours(0,0, 0)))
                }));
                setShowFreezer(false)
                dispatch(projectActions.Actions.setFrozenWarning(true));
                dispatch(projectActions.Actions.setCpmComplete(false))
                FirebaseProjectFunctions.fullCPMCalc(activeProject.projectId!,
                    "false",
                    dispatch,
                    true,
                    Math.floor(FirebaseUsage.timestamp(freezerDate).seconds / 86400) * 86400
                ).then(() => dispatch(projectActions.Actions.setCpmComplete(true)))
            })
            .catch(error => console.log(error));
    }
  }, [activeProject, freezerDate]);

  const unfreezeFlow = useCallback(() => {
    if (activeProject && activeProject.projectId) {
        FirebaseUsage.updateDoc("projects", activeProject.projectId, {
            frozen: false,
            frozenDate: null,
        }).then(() => {
          dispatch(projectActions.Actions.setFrozenWarning(false));
            dispatch(projectActions.Actions.setCpmComplete(false))
            FirebaseProjectFunctions.fullCPMCalc(activeProject.projectId!,
                "false",
                dispatch,
                true,
                FirebaseUsage.timestamp(new Date(new Date().setHours(0,0, 0))).seconds
            ).then(() => dispatch(projectActions.Actions.setCpmComplete(true)))
        })
    }
  }, [activeProject, dispatch]);

  const selectedRisk: RiskModel | null | undefined = useMemo(() => {
      return risks && riskMapping ? risks.find(risk => risk.riskId === riskMapping) : null
  }, [risks, riskMapping]);

    const mapRiskToAllTasksInView = async () => {
        let batch: any[] = []
        let riskTasks = selectedRisk!.tasks ? selectedRisk!.tasks : []
        filteredTaskList.forEach((task: TaskModel) => {
            batch.push({
                ref: FirebaseUsage.doc(COLLECTIONS.TASKS, task.task_id),
                type: 'update',
                data: {
                    risks: task.risks ? [...task.risks, selectedRisk?.riskId] : [selectedRisk?.riskId]
                }
            })
            riskTasks.push(task.task_id)
        })
        await batchUpdate(batch)
        await FirebaseUsage.updateDoc(COLLECTIONS.RISKS, selectedRisk!.riskId, {tasks: riskTasks})
    }

  return (
      <>
          {activeProject && activeProject.frozenDate && showFrozenWarning &&
              <div className={styles.FrozenBanner}>
                  <FontAwesomeIcon icon={faSnowflake} size={'lg'} style={{marginRight: "10px", marginTop: "-2px"}} />
                  {userGrade[MemberOrganizationEnum.SUPER_ACTOR] ?
                      `This project has been frozen on the ${moment(activeProject.frozenDate.toDate()).format("Do MMMM yyyy")}. To begin adding progress information, please unfreeze the project.` :
                        `This project has been frozen on the ${moment(activeProject.frozenDate.toDate()).format("Do MMMM yyyy")}. To add progress information, please contact your project owner to get the project unfrozen.`
                  }
                  <div
                      className={styles.CloseFrozenBanner}>
                  <FontAwesomeIcon
                      icon={faTimesSolid}
                      size={'lg'}
                      onClick={() => {
                          dispatch(projectActions.Actions.setFrozenWarning(false))
                      }}
                  />
                  </div>
              </div>}
          {selectedRisk &&
              <div className={styles.FrozenBanner}>
                  {`Mapping tasks to risk ${selectedRisk.userReference} - ${selectedRisk.description}`}
                  <div
                      className={styles.CloseFrozenBanner}>
                      <Button
                          onClick={() => mapRiskToAllTasksInView()}>
                          Map to all tasks in current view
                      </Button>
                      <Button
                          onClick={() => {
                              dispatch(projectActions.Actions.setRiskMapping(false))
                              dispatch(projectActions.Actions.setView("risks"))
                          }}>
                          Save</Button>
                  </div>
              </div>}
          <div className={styles.Container}>
              <div className={styles.Wrapper}>
                  <div className={styles.Tools}>
                      <div className={styles.FilterItem}>
                          <Button
                              id={"alert"}
                              circular
                              size="tiny"
                              disabled={!hasProjectBeenSelected}
                              className={classNames([
                                  styles.FilterButton,
                                  {[styles.ActiveFilterButton]: searchParameters.alert},
                              ])}
                              onClick={() => {
                                  setHoverButton(null)
                                  dispatch(SearchActions.toggleAlert())
                              }}
                              onMouseEnter={() => handleHoverButton("Tasks with alerts")}
                              onMouseLeave={() => setHoverButton(null)}
                          >
                              <FontAwesomeIcon icon={faExclamation}/>
                          </Button>
                      </div>
                      <div className={styles.FilterItem}>
                          <Button
                              id={"owner"}
                              circular
                              size="tiny"
                              disabled={!hasProjectBeenSelected}
                              className={classNames([
                                  styles.FilterButton,
                                  {[styles.ActiveFilterButton]: searchParameters.taskOwner && (searchParameters.taskOwner[0] === user.userId || searchParameters.taskOwner[1] === user.userEmail)},
                              ])}
                              onClick={() => {
                                  setHoverButton(null)
                                  dispatch(SearchActions.setTaskOwnerFilter(searchParameters.taskOwner[0] === user.userId || searchParameters.taskOwner[1] === user.userEmail ? [] : [user.userId, user.userEmail]))
                              }}
                              onMouseEnter={() => handleHoverButton("My owned tasks")}
                              onMouseLeave={() => setHoverButton(null)}
                          >
                              <FontAwesomeIcon icon={faCrown}/>
                          </Button>
                      </div>
                      <div className={styles.FilterItem}>
                          <Button
                              id={"myTasks"}
                              disabled={!hasProjectBeenSelected}
                              className={classNames([
                                  styles.FilterButton,
                                  {
                                      [styles.ActiveFilterButton]:
                                          searchParameters.taskForces.some(taskForce => taskForce && taskForce[0] === user.userId),
                                  },
                              ])}
                              onClick={toggleOnlyMyTasks}
                              onMouseEnter={() => handleHoverButton("My tasks")}
                              onMouseLeave={() => setHoverButton(null)}
                              circular
                              size="tiny"
                          >
                              <FontAwesomeIcon icon={faHandshakeAlt}/>
                          </Button>
                      </div>
                      <div className={styles.FilterItem}>
                          <Button
                              id={"noTaskForce"}
                              disabled={!hasProjectBeenSelected}
                              className={classNames([
                                  styles.FilterButton,
                                  {
                                      [styles.ActiveFilterButton]:
                                          searchParameters.noTaskForce,
                                  },
                              ])}
                              onClick={() => {
                                  setHoverButton(null)
                                  dispatch(SearchActions.setNoTaskForceFilter(!searchParameters.noTaskForce))
                              }}
                              onMouseEnter={() => handleHoverButton("Tasks with no task force")}
                              onMouseLeave={() => setHoverButton(null)}
                              circular
                              size="tiny"
                          >
                              <FontAwesomeIcon icon={faUsersSlash}/>
                          </Button>
                      </div>
                      <div className={styles.FilterItem}>
                          <Button circular size="tiny"
                                  id={"sprint"}
                                  disabled={!activeProject || !activeProject.projectId || !activeProject.lastSnapshotTimestamp}
                                  active={props.isOpenedCalendar}
                                  className={classNames([
                                      styles.FilterButton,
                                      {
                                          [styles.ActiveFilterButton]:
                                          projectView === "sprint",
                                      },
                                  ])}
                                  // className={classNames({
                                  //     // [styles.BetaButton]: true,
                                  //     [styles.ButtonCalendar]: projectView === "sprint",
                                  // })}
                                  onClick={() => {
                                      setHoverButton(null)
                                      dispatch(projectActions.Actions.setView(projectView === "sprint" ? "task" : "sprint"))
                                  }}
                                  onMouseEnter={() => handleHoverButton("Sprint view")}
                                  onMouseLeave={() => setHoverButton(null)}
                          >
                              {/*<span className={styles.BetaContainer}><p className={styles.BetaTag}>BETA</p></span>*/}
                              <FontAwesomeIcon icon={faPersonRunningFast}/>
                          </Button>
                      </div>
                      <div className={styles.FilterItem}>
                          <Button circular size="tiny"
                                  id={"addTask"}
                              // disabled={!activeProject || !activeProject.projectId}
                                  disabled={true}
                                  className={styles.AddButton}
                                  onClick={() => {
                                      setHoverButton(null)
                                      setNewTaskModalOpen(true)
                                  }}
                                  onMouseEnter={() => handleHoverButton("Add new task")}
                                  onMouseLeave={() => setHoverButton(null)}
                          >
                              <FontAwesomeIcon icon={faPlus}/>
                          </Button>
                      </div>
                      <div className={styles.FilterItem}>
                          <Button circular size="tiny"
                                  id={"milestones"}
                                  disabled={!activeProject || !activeProject.projectId}
                              // style={!showMilestones && {backgroundColor: "white"}}
                                  active={showMilestones}
                                  className={classNames([
                                      styles.FilterButton,
                                      {
                                          [styles.ActiveFilterButton]:
                                          showMilestones,
                                      },
                                  ])}
                                  onClick={() => {
                                      setHoverButton(null)
                                      dispatch(searchActions.SearchActions.setIncludeMilestones(!showMilestones))
                                  }}
                                  onMouseEnter={() => handleHoverButton("Show milestones")}
                                  onMouseLeave={() => setHoverButton(null)}
                          >
                              <FontAwesomeIcon icon={faDiamond}/>
                          </Button>
                      </div>
                      {!dateFilterOpen && <div
                          id={"search"}
                          style={{marginRight: "0px"}}
                          className={classNames(styles.FilterItem, styles.SearchBar, {
                              [styles.Expanded]: expandedSearchBar,
                          })}
                      >
                          <Form onSubmit={addChip}
                                onMouseEnter={() => handleHoverButton("Search tasks")}
                                onMouseLeave={() => setHoverButton(null)}
                          >
                              <Input
                                  disabled={!hasProjectBeenSelected}
                                  className={classNames(styles.InputWrapper, {
                                      [styles.ActiveFilterSearchInput]:
                                      (searchParameters.searchText ||
                                          searchParameters.chipList.length) &&
                                      expandedSearchBar,
                                  })}
                                  size="small"
                                  actionPosition="left"
                                  ref={searchInputRef}
                                  action={{
                                      icon: <FontAwesomeIcon icon={faSearch}/>,
                                      loading: searchBarLoading,
                                      disabled: !hasProjectBeenSelected,
                                      className: classNames({
                                          [styles.ActiveFilterSearchButton]:
                                          searchParameters.searchText ||
                                          searchParameters.chipList.length,
                                      }),
                                  }}
                                  placeholder="Search..."
                                  onChange={async (evt) => {
                                      dispatch(SearchActions.setSearchBarLoading(true));
                                      await handleChangeSearchValue(evt.target.value);
                                  }}
                              />
                          </Form>
                          <div className={styles.CalendarSearch}
                               id={"timeFilter"}
                               onClick={() => {
                                   setHoverButton(null)
                                   setDateFilterOpen(prevState => !prevState)
                               }}
                               onMouseEnter={() => handleHoverButton("Apply time filter")}
                               onMouseLeave={() => setHoverButton(null)}
                          >
                              <FontAwesomeIcon
                                  className={styles.CalendarSearchButton}
                                  icon={faCalendar}/>
                          </div>
                      </div>}
                      {dateFilterOpen &&
                          <div className={styles.DateRangeFilter}>
                              <div
                                  style={{marginRight: "0px", marginTop: "10px"}}
                                  className={classNames(styles.FilterItem, styles.SearchBar, {
                                      [styles.Expanded]: expandedSearchBar,
                                  })}
                              >
                                  <Form onSubmit={addChip}>
                                      <Input
                                          disabled={!hasProjectBeenSelected}
                                          className={classNames(styles.InputWrapper, {
                                              [styles.ActiveFilterSearchInput]:
                                              (searchParameters.searchText ||
                                                  searchParameters.chipList.length) &&
                                              expandedSearchBar,
                                          })}
                                          size="small"
                                          actionPosition="left"
                                          ref={searchInputRef}
                                          action={{
                                              icon: <FontAwesomeIcon icon={faSearch}/>,
                                              loading: searchBarLoading,
                                              disabled: !hasProjectBeenSelected,
                                              className: classNames({
                                                  [styles.ActiveFilterSearchButton]:
                                                  searchParameters.searchText ||
                                                  searchParameters.chipList.length,
                                              }),
                                          }}
                                          placeholder="Search..."
                                          onChange={async (evt) => {
                                              dispatch(SearchActions.setSearchBarLoading(true));
                                              await handleChangeSearchValue(evt.target.value);
                                          }}
                                      />
                                  </Form>
                                  <div className={styles.CalendarSearch}
                                       onClick={() => {
                                           dispatch(searchActions.SearchActions.setStartDate(null))
                                           dispatch(searchActions.SearchActions.setFinishDate(null))
                                           setDateFilterOpen(prevState => !prevState)
                                       }}>
                                      <FontAwesomeIcon
                                          className={styles.CalendarSearchButton}
                                          icon={faXmark}/>
                                  </div>
                              </div>
                              From:
                              <div style={{marginRight: "10px", zIndex: 350}}>
                                  <DatePicker enableTabLoop={false}
                                              dateFormat="dd-MMM-yyyy"
                                              showMonthDropdown
                                              showYearDropdown
                                              scrollableYearDropdown
                                              yearDropdownItemNumber={30}
                                              selected={searchParameters.startDate ? new Date(searchParameters.startDate) : null}
                                              maxDate={searchParameters.finishDate ? new Date(searchParameters.finishDate) : null}
                                              onChange={(date) => dispatch(searchActions.SearchActions.setStartDate(date ? date.getTime() : null))}
                                  />
                              </div>
                              To:
                              <div style={{marginRight: "10px", zIndex: 350}}>
                                  <DatePicker enableTabLoop={false}
                                              dateFormat="dd-MMM-yyyy"
                                              showMonthDropdown
                                              showYearDropdown
                                              scrollableYearDropdown
                                              yearDropdownItemNumber={30}
                                              selected={searchParameters.finishDate ? new Date(searchParameters.finishDate) : null}
                                              minDate={searchParameters.startDate ? new Date(searchParameters.startDate) : null}
                                              onChange={(date) => dispatch(searchActions.SearchActions.setFinishDate(date ? date.getTime() : null))}
                                  />
                              </div>
                          </div>}
                      <div className={styles.FilterItem}>
                          <Button circular size="tiny"
                                  id={"Show network diagram"}
                                  disabled={!activeProject || !activeProject.projectId || (!activeTask && !activeWorkPackage)}
                                  //   disabled={true}
                                    // style={!showMilestones && {backgroundColor: "white"}}
                                  active={false}
                                  className={classNames([
                                      styles.FilterButton,
                                      {
                                          [styles.ActiveFilterButton]:
                                          isDagOpen,
                                      },
                                  ])}
                                  onClick={() => {
                                      setHoverButton(null)
                                      dispatch(projectActions.Actions.setDAGOpen(!isDagOpen))
                                  }}
                                  onMouseEnter={() => handleHoverButton("Show network")}
                                  onMouseLeave={() => setHoverButton(null)}
                          >
                              <FontAwesomeIcon icon={faDiagramProject}/>
                          </Button>
                      </div>
                      <div className={styles.FilterItem}>
                          <Button circular size="tiny"
                                  id={"focusOnTask"}
                                  disabled={!activeTask}
                                  active={false}
                                  className={styles.FilterButton}
                                  onClick={() => {
                                      setHoverButton(null)
                                      dispatch(taskActions.Actions.setGoToTask(true))
                                  }}
                                  onMouseEnter={() => handleHoverButton("Focus on task")}
                                  onMouseLeave={() => setHoverButton(null)}
                          >
                              <FontAwesomeIcon icon={faLocationCrosshairs}/>
                          </Button>
                      </div>
                      {userGrade[MemberOrganizationEnum.SUPER_ACTOR] &&
                          <Dropdown
                              icon={null}
                              position="top left"
                              open={showFreezer}
                              onBlur={() => setShowFreezer(false)}
                              trigger={
                              <div className={styles.FilterItem}>
                                  <Button circular size="tiny"
                                          id={"freezeFlow"}
                                          disabled={!activeProject || !activeProject.projectId}
                                          active={false}
                                          className={classNames([
                                              styles.FilterButton,
                                              {
                                                  [styles.ActiveFilterButton]:
                                                  showFreezer
                                              },
                                          ])}
                                          onClick={() => {
                                              if (activeProject && activeProject.frozen) {
                                                  unfreezeFlow();
                                              } else {
                                                  setHoverButton(null)
                                                  setShowFreezer(prevState => !prevState)
                                              }
                                          }}
                                          onMouseEnter={() => handleHoverButton("Freeze flow")}
                                          onMouseLeave={() => setHoverButton(null)}
                                  >
                                      <FontAwesomeIcon icon={activeProject && activeProject.frozen ? faFire : faSnowflake}/>
                                  </Button>
                              </div>}
                              style={{ zIndex: 300 }}         // ensure the whole dropdown is above page layers
                          >
                              <DropdownMenu style={{ marginTop: '0px', overflow: 'visible' }}>
                                  <p className={styles.FreezerLabel}>Select frozen data date for the project:</p>
                                  <div className={styles.FreezerContainer}>
                                      <DatePicker
                                          className={styles.FreezerDatePicker}
                                          selected={freezerDate}
                                          onChange={(date) => setFreezerDate(date)}
                                          dateFormat="dd-MMM-yyyy"
                                          enableTabLoop={false}
                                          portalId="freezer-datepicker-portal"
                                          popperPlacement="bottom-start"
                                      />
                                      <div id="freezer-datepicker-portal" style={{ position: 'relative', zIndex: 9999 }} />
                                      <Button
                                          className={styles.FreezerButton}
                                          primary
                                          disabled={!freezerDate}
                                          onClick={() => commitFreezerDate()}
                                      >
                                          <Icon name={"snowflake"}  />
                                          Freeze
                                      </Button>
                                  </div>
                              </DropdownMenu>
                          </Dropdown>}
                      {activeProject && workPackages && workPackages.length > 0 && <div
                          id={"workPackages"}
                          className={styles.FilterItem}
                          onMouseEnter={() => handleHoverButton("Work package filter")}
                          onMouseLeave={() => setHoverButton(null)}
                      >
                          <ReportDropdown/>
                      </div>}
                      <ChipsList/>
                      <OnlineUsers/>
                  </div>
                  <div className={styles.View}>
                      {successorsView || predecessorsView ? (
                          <Button
                              className={styles.BtnCloseView}
                              onClick={() => closeView(view)}
                          >
                              {view.substring(0, 1).toUpperCase() +
                                  view.substring(1, view.length)}
                                <span style={{position: "relative"}}>
                                  <FontAwesomeIcon icon={faTimes}/>
                                </span>
                          </Button>
                      ) : (
                          <div className={styles.DaysBanked}></div>
                      )}
                  </div>
              </div>
              <div className={styles.InteractionBar}>
                  <Button circular size="tiny"
                          id={"checklists"}
                          disabled={!activeProject || !activeProject.projectId}
                          active={checklists}
                          className={classNames({
                              // [styles.BetaButton]: true,
                              [styles.ButtonCalendar]: checklists,
                          })}
                          onClick={() => {
                              setHoverButton(null)
                              setChecklists(!checklists)
                              if (map) {
                                  setMap(false)
                              }
                              dispatch(projectActions.Actions.setView(checklists ? "task" : "checklists"))
                          }}
                          onMouseEnter={() => handleHoverButton("Checklists")}
                          onMouseLeave={() => setHoverButton(null)}
                  >
                      {/*<span className={styles.BetaContainer}><p className={styles.BetaTag}>BETA</p></span>*/}
                      <FontAwesomeIcon icon={faCheck}/>
                  </Button>
              {projectView === 'gantt' && activeTask && <Button circular size="tiny"
                                id={"taskDetails"}
                  // disabled={!activeProject || !activeProject.projectId || quality}
                  //               disabled={true}
                  //               active={props.isOpenedCalendar}
                                  className={classNames({
                                      [styles.ButtonCalendar]: showTaskDetails,
                                  })}
                                              onClick={() => {
                                    setHoverButton(null)
                                    dispatch(projectActions.Actions.setOpenTaskDetails(!showTaskDetails))
                                }}
                                onMouseEnter={() => handleHoverButton("Show task details")}
                                onMouseLeave={() => setHoverButton(null)}
              >
                  <FontAwesomeIcon icon={faMemoCircleInfo}/>
              </Button>}
              {projectView === 'gantt' && <Button circular size="tiny"
                                id={"printGantt"}
                      // disabled={!activeProject || !activeProject.projectId || quality}
                            disabled={true}
                          active={props.isOpenedCalendar}
                          // className={classNames({
                          //     [styles.ButtonCalendar]: gannt,
                          // })}
                          onClick={() => {}}
                            onMouseEnter={() => handleHoverButton("Print Gantt chart")}
                            onMouseLeave={() => setHoverButton(null)}
              >
                      <FontAwesomeIcon icon={faPrint}/>
                  </Button>}
                  <Button circular size="tiny"
                          id={"gantt"}
                          disabled={!activeProject || !activeProject.projectId || projectView === "quality"}
                          // active={props.isOpenedCalendar}
                          className={classNames({
                              [styles.BetaButton]: true,
                              [styles.ButtonCalendar]: projectView === "gantt",
                          })}
                          onClick={() => {
                              setHoverButton(null)
                              dispatch(projectActions.Actions.setView(projectView === "gantt" ? "task" : "gantt"))
                          }}
                          onMouseEnter={() => handleHoverButton("Gantt view")}
                          onMouseLeave={() => setHoverButton(null)}
                  >
                      <span className={styles.BetaContainer}><p className={styles.BetaTag}>BETA</p></span>
                      <FontAwesomeIcon icon={faChartGantt}/>
                  </Button>
                  <Button circular size="tiny"
                          id={"risks"}
                          disabled={!activeProject || !activeProject.projectId}
                          // active={props.isOpenedCalendar}
                          className={classNames({
                              [styles.BetaButton]: true,
                              [styles.ButtonCalendar]: projectView === "risks",
                          })}
                          onClick={() => {
                              setHoverButton(null)
                              if (map) {
                                  setMap(false)
                              }
                              dispatch(projectActions.Actions.setView(projectView === "risks" ? "task" : "risks"))
                          }}
                          onMouseEnter={() => handleHoverButton("Risk view")}
                          onMouseLeave={() => setHoverButton(null)}
                  >
                      <span className={styles.BetaContainer}><p className={styles.BetaTag}>BETA</p></span>
                      <FontAwesomeIcon icon={faChartCandlestick}/>
                  </Button>
                  {/*{activeProject && activeProject.contractId && <Button circular size="tiny"*/}
                  {/*        id={"dashboard"}*/}
                  {/*        disabled={!activeProject || !activeProject.contractId}*/}
                  {/*    // active={props.isOpenedCalendar}*/}
                  {/*        className={classNames({*/}
                  {/*            [styles.ButtonCalendar]: projectView === "dashboard",*/}
                  {/*        })}*/}
                  {/*        onClick={() => {*/}
                  {/*            setHoverButton(null)*/}
                  {/*            dispatch(projectActions.Actions.setView(gannt ? "task" : "dashboard"))*/}
                  {/*        }}*/}
                  {/*        onMouseEnter={() => handleHoverButton("Dashboard view")}*/}
                  {/*        onMouseLeave={() => setHoverButton(null)}*/}
                  {/*>*/}
                  {/*    /!*<span className={styles.BetaContainer}><p className={styles.BetaTag}>BETA</p></span>*!/*/}
                  {/*    <FontAwesomeIcon icon={faGauge}/>*/}
                  {/*</Button>}*/}
                  <Button circular size="tiny"
                          id={"change"}
                          disabled={!activeProject || !activeProject.projectId}
                          active={props.isOpenedCalendar}
                          className={classNames({
                              [styles.BetaButton]: true,
                              [styles.ButtonCalendar]: projectView === "change",
                          })}
                          onClick={() => {
                              setHoverButton(null)
                              dispatch(projectActions.Actions.setView(projectView === "change" ? "task" : "change"))
                          }}
                          onMouseEnter={() => handleHoverButton("Change log")}
                          onMouseLeave={() => setHoverButton(null)}
                  >
                      <span className={styles.BetaContainer}><p className={styles.BetaTag}>BETA</p></span>
                      <FontAwesomeIcon icon={faReflectHorizontal}/>
                  </Button>
                  <Button circular size="tiny"
                          id={"workpacks"}
                          disabled={!activeProject || !activeProject.projectId || !projectHasWorkPackages}
                          active={props.isOpenedCalendar}
                          className={classNames({
                              [styles.BetaButton]: true,
                              [styles.ButtonCalendar]: projectView === "workpacks",
                          })}
                          onClick={() => {
                              setHoverButton(null)
                              if (projectView === 'task' && activeTask) {
                                  dispatch(taskActions.Actions.setActiveTask(null))
                              }
                              if (projectView === 'workpacks' && activeWorkPackage) {
                                  dispatch(workPackageActions.Actions.setActiveWorkPackage(null))
                              }
                              dispatch(projectActions.Actions.setView(projectView === "workpacks" ? "task" : "workpacks"))
                          }}
                          onMouseEnter={() => handleHoverButton("Work packages")}
                          onMouseLeave={() => setHoverButton(null)}
                  >
                      <span className={styles.BetaContainer}><p className={styles.BetaTag}>BETA</p></span>
                      <FontAwesomeIcon icon={faBoxOpenFull}/>
                  </Button>
                  <Button circular size="tiny"
                          id={"quality"}
                          disabled={!activeProject || !activeProject.projectId}
                          active={props.isOpenedCalendar}
                          className={classNames({
                              // [styles.BetaButton]: true,
                              [styles.ButtonCalendar]: projectView === "quality",
                          })}
                          onClick={() => {
                              setHoverButton(null)
                              if (map) {
                                  setMap(false)
                              }
                              dispatch(projectActions.Actions.setView(projectView === "quality" ? "task" : "quality"))
                          }}
                          onMouseEnter={() => handleHoverButton("Quality view")}
                          onMouseLeave={() => setHoverButton(null)}
                  >
                      {/*<span className={styles.BetaContainer}><p className={styles.BetaTag}>BETA</p></span>*/}
                      <FontAwesomeIcon icon={faChartPie}/>
                  </Button>
                  <Button circular size="tiny"
                          id={"map-button"}
                          disabled={!activeProject || !activeProject.projectId || projectView === 'quality'}
                          active={props.isOpenedCalendar}
                          className={classNames({
                              // [styles.BetaButton]: true,
                              [styles.ButtonCalendar]: map,
                          })}
                          onClick={() => {
                              setHoverButton(null)
                              setMap(!map)
                              dispatch(projectActions.Actions.setView(map ? "task" : "task-map"))
                          }}
                          onMouseEnter={() => handleHoverButton("Open map")}
                          onMouseLeave={() => setHoverButton(null)}
                  >
                      {/*<span className={styles.BetaContainer}><p className={styles.BetaTag}>BETA</p></span>*/}
                      <FontAwesomeIcon icon={faMapLocationDot}/>
                  </Button>
                  <Button
                      id={"calendar"}
                      disabled={!Boolean(activeProject)}
                      className={classNames({
                          [styles.ButtonCalendar]: props.isOpenedCalendar,
                      })}
                      onClick={() => {
                          setHoverButton(null)
                          props.openSpecificAdditional("calendar", !props.isOpenedCalendar)
                      }}
                      onMouseEnter={() => handleHoverButton("Task calendar")}
                      onMouseLeave={() => setHoverButton(null)}
                      active={props.isOpenedCalendar}
                  >
                      <FontAwesomeIcon icon={faCalendar}/>
                  </Button>
                  <Button
                      id={"ledger"}
                      disabled={!Boolean(activeProject)}
                      className={
                          activeTask
                              ? classNames({
                                  [styles.ButtonLedgerActive]: props.isOpenedLedger,
                              })
                              : classNames({[styles.ButtonLedger]: props.isOpenedLedger})
                      }
                      onClick={() => {
                          setHoverButton(null)
                          props.openSpecificAdditional("ledger", !props.isOpenedLedger);
                          updateUserTaskSeenHandler();
                      }}
                      onMouseEnter={() => handleHoverButton("Task ledger")}
                      onMouseLeave={() => setHoverButton(null)}
                      active={props.isOpenedLedger}
                  >
                      <FontAwesomeIcon icon={faCommentsAlt}/>
                  </Button>
                  <Button
                      id={"member"}
                      disabled={!Boolean(activeProject)}
                      className={classNames({
                          [styles.ButtonMember]: props.isOpenedMember,
                      })}
                      onClick={() => {
                          setHoverButton(null)
                          props.openSpecificAdditional("member", !props.isOpenedMember)
                      }}
                      onMouseEnter={() => handleHoverButton("Project team")}
                      onMouseLeave={() => setHoverButton(null)}
                      active={props.isOpenedMember}
                  >
                      <FontAwesomeIcon icon={faUsers}/>
                  </Button>
                  {/*<Button*/}
                  {/*    disabled={!Boolean(activeProject)}*/}
                  {/*    className={classNames({*/}
                  {/*        [styles.ButtonMember]: props.isOpenedMember,*/}
                  {/*    })}*/}
                  {/*    onClick={() =>*/}
                  {/*        fetch('https://europe-west3-flowledgerprod.cloudfunctions.net/create-chat-context/?projectId=SmVKcpBaGZqhtM1Kc9Rh',*/}
                  {/*              {*/}
                  {/*                  method: 'POST',*/}
                  {/*                  mode: 'no-cors'*/}
                  {/*              })*/}
                  {/*            .then(() => console.log())*/}
                  {/*}*/}
                  {/*    active={props.isOpenedMember}*/}
                  {/*>*/}
                  {/*    <FontAwesomeIcon icon={faUsers}/>*/}
                  {/*</Button>*/}
              </div>
              {hoverButton && !(expandedSearchBar && hoverButton.text === 'Search tasks') && <div
                  className={styles.HoverTooltip}
                  style={{top: hoverButton.y, left: hoverButton.x}}
              >{hoverButton.text}</div>}
          </div>
          <div className={styles.BreadcrumbBar}>
        <span className="flowledger-header-subtitle" style={newWbsAddress === "WBS Path:" ? {
            color: "grey"} : {
            maxWidth: "100vw",
            overflow: "hidden",
            maxHeight: "20px",
            textOverflow: "ellipsis",
        }}>
          {activeProject && projectView !== 'risks' ? `${newWbsAddress}` : ``}
        </span>
          </div>
          {newTaskModalOpen &&
              <NewTaskModal props={{setNewTaskModalOpen, newTaskModalOpen, projectId: activeProject!.projectId}}/>}
      </>
  );
};
